import { type DeploymentEnv, ENV_FLAG_CLASS, ENV_FLAG_CSS, type EnvFlagLocale, envFlag } from "../env";

export interface EnvironmentFlagProps {
  /** `parseDeploymentEnv(APP_ENV)`; production renders nothing. */
  env: DeploymentEnv;
  locale?: EnvFlagLocale;
}

/** Stripe and label on every test (and local) page. Renders nothing in production. */
export function EnvironmentFlag({ env, locale = "de" }: EnvironmentFlagProps) {
  const flag = envFlag(env, locale);
  if (!flag) return null;
  return (
    <div className={ENV_FLAG_CLASS} data-env={flag.env} title={flag.title}>
      <style href="zuvo-env-flag" precedence="default">
        {ENV_FLAG_CSS}
      </style>
      <span className="zuvo-env-flag__label">{flag.label}</span>
    </div>
  );
}

export default EnvironmentFlag;
